import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { LightCourse } from "@domain/lms/course/course";
import { theme } from "@ui/styles/theme";
import { gap } from "@ui/styles/utils";
import {
	EyeIcon,
	LanguageIcon,
	LevelOneIcon,
	LevelThreeIcon,
	LevelTwoIcon,
	StarIcon,
	TimeIcon,
} from "@ui/components/icons";
interface CourseDetailsProps extends React.HTMLAttributes<HTMLDivElement> {
	course: LightCourse;
	hideLanguage?: boolean;
}
export const CourseDetails: React.FC<CourseDetailsProps> = ({ course, hideLanguage, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{course.duration ? (
				<div>
					<TimeIcon color={theme.colors.black} />
					<span>{course.duration} min</span>
				</div>
			) : null}
			{course.feedbacks.meanScore ? (
				<div>
					<BlackStarIcon />
					<span>{course.feedbacks.meanScore.toFixed(1)}</span>
				</div>
			) : null}
			{course.views.count ? (
				<div>
					<EyeIcon />
					<span>{course.views.count}</span>
				</div>
			) : null}
			{!hideLanguage && (
				<div>
					<LanguageIcon />
					<span>{I18n.t(`language.${course.language}`)}</span>
				</div>
			)}
			{course.level && !course.feedbacks.meanScore ? ( // No mean score then display level.
				<div>
					{course.level == "BEGINNER" ? <LevelOneIcon /> : undefined}
					{course.level == "INTERMEDIATE" ? <LevelTwoIcon /> : undefined}
					{course.level == "ADVANCED" ? <LevelThreeIcon /> : undefined}
					<span>{I18n.t(`level.${course.level}`)}</span>
				</div>
			) : null}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	font-weight: 300 !important;
	${({ theme }) => theme.textStyles.text};
	${gap(18, "row")}

	> div {
		display: flex;
		align-items: center;
		vertical-align: center;

		span {
			margin-top: 2px;
		}
	}

	svg {
		margin-right: 2px;
	}
`;

const BlackStarIcon = styled(StarIcon)`
	width: 15px;
	height: 15px;
	path {
		fill: ${({ theme }) => theme.colors.black};
	}
`;
